import React, { useContext } from 'react';
import { H4 } from '@xo-union/tk-ui-typography';
import { useMobileMedia } from '@xo-union/tk-ui-breakpoints';
import { Link } from 'react-router-dom';
import { DisplayButton } from '@xo-union/tk-ui-links';
import Icon from '@xo-union/tk-component-icons';
import DashboardActionButtons from '../DashboardActionButtons';
import styles from './index.scss';
import { PageCardUIContext } from '../../PageCardUIContext';
import { reorderPagesRoute } from '../../helpers/routes';
import useIsLiteSite from '../../helpers/useIsLiteSite';
import { useWebsiteLayoutContext } from '../../context/WebsiteLayoutContext';

interface Props {
  showActionButtons?: boolean;
}

const PageSectionHeader: React.FC<Props> = ({ showActionButtons = true }) => {
  const { currentLayout } = useWebsiteLayoutContext();
  const { updateAllPageCards, allPagesClosed } = useContext(PageCardUIContext);
  const mobileMedia = useMobileMedia();
  const isLiteSite = useIsLiteSite();

  const isSinglePageSite = currentLayout === 'single-page';
  const pagesOrSections = isSinglePageSite ? 'Sections' : 'Pages';
  const lowerCasePagesOrSections = pagesOrSections.toLowerCase();
  return (
    <div className={styles.pageSectionHeader}>
      <H4 as="h2">{pagesOrSections}</H4>
      <div className={styles.actionContainer}>
        <Link data-testid="reorder-pages" to={reorderPagesRoute}>
          {`Reorder ${lowerCasePagesOrSections}`}
        </Link>
        {isLiteSite && (
          <DisplayButton
            data-testid="collapse-or-expand-pages"
            className={styles.displayLink}
            onClick={() => updateAllPageCards(!allPagesClosed)}
            color="primary"
          >
            <Icon
              size="sm"
              name="caret_up"
              className={allPagesClosed ? styles.expandCaretOne : styles.collapseCaretOne}
            />
            <Icon
              size="sm"
              name="caret_down"
              className={allPagesClosed ? styles.expandCaretTwo : styles.collapseCaretTwo}
            />
            {`${allPagesClosed ? 'Expand' : 'Collapse'} All`}
          </DisplayButton>
        )}
        {mobileMedia.no && showActionButtons && <DashboardActionButtons className={styles.actionButtons} />}
      </div>
    </div>
  );
};

export default PageSectionHeader;
